// Hooks
import { useState, useMemo } from 'react';

// MUI
import { ThemeProvider, createTheme } from '@mui/material';

// React Router
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

// Pages
import Root from "./pages/Root";
import Home from "./pages/home/Home";
import Create from "./pages/create/Create";
import Profile from "./pages/profile/Profile";
import Edit from "./pages/edit/Edit";
import Logout from "./pages/logout/Logout";
import Error from "./pages/error/Error";

// Contexts
import CartProvider from './contexts/CartProvider';
import SpentProvider from './contexts/SpentProvider';

export default function App() {

  const [myMode, setMyMode] = useState(localStorage.getItem("theme") ? localStorage.getItem("theme") : "light");

  const myTheme = useMemo(
    () =>
      createTheme({
        // @ts-ignore
        palette: { mode: myMode },
      }),
    [myMode]
  );

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<Root myMode={myMode} setMyMode={setMyMode} />}>
        <Route index element={<Logout />} />
        <Route path="home" element={<Home />} />
        <Route path="create" element={<Create />} />
        <Route path="profile" element={<Profile />} />
        <Route path="edit" element={<Edit />} />
        <Route path="*" element={<Error />} />
      </Route>
    )
  );

  return (
    <CartProvider>
      <SpentProvider>
        <ThemeProvider theme={myTheme}>
          <RouterProvider router={router} />
        </ThemeProvider>
      </SpentProvider>
    </CartProvider>
  )
}